import React, { forwardRef } from "react";
import isEmail from "validator/lib/isEmail";
import { Control, RegisterOptions } from "react-hook-form";
import { CpInputField } from "./cp-input-field.component";

type CpInputFieldEmailProps = {
  control: Control<any>;
  fieldName: string;
  rules?: RegisterOptions;
} & Omit<
  React.ComponentPropsWithRef<typeof CpInputField>,
  "control" | "fieldName" | "rules"
>;

export const CpInputFieldEmail = forwardRef<
  HTMLInputElement,
  CpInputFieldEmailProps
>(function CpInputFieldEmail(props, ref) {
  const { control, fieldName, rules = {}, ...inputProps } = props;

  return (
    <CpInputField
      control={control}
      fieldName={fieldName}
      rules={{
        ...rules,
        validate: {
          ...rules?.validate,
          isValidEmail: (v: string) =>
            !v?.length || isEmail(v) || "Field must be email",
        },
      }}
      ref={ref}
      {...inputProps}
    />
  );
});
